$(document).ready(function () {
  var visibleMeganav;
  var visibleSubMeganav;

  const megaNavUnderlay = $('.meganav__underlay');
  const sliderowTitle = $('.sliderow__title');
  const slideRow = $('.sliderow');
  const slideRoleWrapper = $('.sliderule__wrapper');

  $('.sliderow__title-custom').click(function () {
    closeToggleNav();
    const _this = this.parentElement;
    var meganavMobile = _this.getElementsByClassName("c-meganav-mobile")[0];
    var navTitle = $(this)[0].innerHTML;

    const curSliderule__wrapper = $(this).parent().parent();
    curSliderule__wrapper.css('opacity', 1);

    $(this).addClass('nav-category-title');
    $(this).attr('data-nav-title', $(this)[0].innerText)

    if (visibleMeganav != meganavMobile) {
      closeAllVisibleMenus();
    };

    // set new meganav to visible
    if (meganavMobile.style.visibility != "visible") {
      meganavMobile.style.visibility = "visible";
      meganavMobile.style.opacity = 1;
      _this.style.height = '450px';

      if (navTitle.includes('Curtain')) {
        _this.style.height = '250px';
      } else if (navTitle.includes('Shades')) {
        _this.style.height = '250px';

        $('.sliderow').each((i, el) => {
          if (el.style.height == '465px' && $(el)[0].children[0].innerText == 'Curtains') {
            el.style.height = '300px'
            return false;
          } else if (el.style.height == '400px' && $(el)[0].children[0].innerText == 'Curtains') {
            el.style.height = '300px'
            return false;
          } else if (el.style.height == '500px' && $(el)[0].children[0].innerText == 'Curtains') {
            el.style.height = '300px'
            return false;
          }
        })

      } else if (navTitle.includes('Hardware')) {
        _this.style.height = '150px';
      } else if (navTitle.includes('Decor')) {
        _this.style.height = '200px';
      }

      const thisTitle = $(this).text();
      $(this).css('display', 'flex');
      $(this).find('.accordion__title').css('display', 'none');

      if (thisTitle == 'Shades') {
        $(this).css('top', '-50px');
      } else if (thisTitle == 'Hardware') {
         $(this).css('top', '-100px');
      } else if (thisTitle == 'Decor') {
         $(this).css('top', '-150px');
      } else if (thisTitle == 'Design Center') {
        $(this).css('top', '-300px');
      }
    } else {
      meganavMobile.style.visibility = "hidden";
      meganavMobile.style.opacity = 0;
      _this.style.height = 0;
      visibleMeganav = null;
    }
  });

  $(".navlink--toplevel").click(function () {
    const _this = this.parentElement;
    var meganav = _this.getElementsByClassName("c-meganav")[0];
    const megaNavText = $(this).find('.navtext');
    $('.navtext').css('font-weight', 400);

    if (visibleMeganav != meganav) {
      closeAllVisibleMenus();
    }

    // set new meganav to visible
    if (meganav.style.visibility != "visible") {
      meganav.style.visibility = "visible";
      meganav.style.opacity = 1;
      visibleMeganav = meganav;
      megaNavText.css('font-weight', 700);
    } else {
      meganav.style.visibility = "hidden";
      meganav.style.opacity = 0;
      visibleMeganav = null;
      megaNavUnderlay.css('visibility', 'hidden');
    }
  });

  $(".c-meganav__category").click(function () {
    let navLink = $(this).attr("href");
    if (navLink == undefined) {
      return;
    } else if (navLink !== "#") {
      window.location.href = navLink;
    } else {
      var subMeganav = this.getElementsByClassName("c-sub-meganav")[0];

      if (visibleSubMeganav != subMeganav) {
        closeVisibleSubMeganav();
      }

      const curSliderule__wrapper = $(this).parent().parent().parent().parent().parent();
      const navCategoryTitle = $(this)[0].innerText.replace('\n', '');
      const sliderow = curSliderule__wrapper.find('.sliderow');
      curSliderule__wrapper.css('opacity', 1);
      $('.nav-category-title .nav-title-custom').text(navCategoryTitle);

      // set new sub meganav to visible
      if (subMeganav.style.visibility != "visible") {
        subMeganav.style.visibility = "visible";
        subMeganav.style.opacity = 1;

        var width = $(window).width();
        if (width > 1440){
          visibleSubMeganav = subMeganav;
        }

        megaNavUnderlay.css('visibility', 'visible')
      }

      if (width > 1133 || width == undefined) return;

      const _thisChildren = $(this).find('nav[data-mega-nav]');
      sliderow.css('height', `${50 + _thisChildren.height()}px`);
    }
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".header__desktop__bar__c").length) {
      closeAllVisibleMenus();
    }
  });

  $('.header__mobile__hamburger').click(function () {
    if (!$(event.target).closest(".header__desktop__bar__c").length) {
      closeAllVisibleMenus();
      sliderowTitle.css('visibility', 'visible');
      slideRow.css('height', 0);
      $('.c-meganav-mobile').css({
        'visibility': 'invisible',
        'opacity': 0,
        'top': 0 //check
      })
       $('.sliderow__title-custom').css({
        'top': 0,
        'justify-content': 'space-between'
       });
      $('.sliderow__title-custom .accordion__title').css({
        'display': 'flex'
      });
    };
  });

  $('.toggle-nav').click(function () {
    if ($(this).find('.accordion__title').length == 0) return;

    const _this = $(this).parent();
    const navOptions = _this.find('.c-meganav__option-wrapper');
    const accordionTitle = $(this).find('.accordion__title');
    const _thisGrandParent = _this.parents('.sliderow');
    const _thisTitleWrapper = _this.find('.c-meganav__category-label-mobile');

    setTimeout(() => {
      _thisGrandParent.css('height', `${300 + navOptions.height()}px`);
    }, 50);

    if (navOptions.hasClass('hide')) {
      closeToggleNav();
      navOptions.removeClass('hide');
      accordionTitle.addClass('is-open')
      _thisTitleWrapper.css({
      'background': '#212121',
      'color': '#fff',
      'position': 'relative',
      'top': '5px'
    })
    _thisTitleWrapper.find('span').css('color', '#fff')
      return false;
    } else {
      navOptions.addClass('hide');
      accordionTitle.removeClass('is-open')
      _thisTitleWrapper.css({
      'background': '#fff',
      'color': '#212121',
      'position': 'static'
      })
      _thisTitleWrapper.find('span').css('color', '#212121')
      return false;
    };
  });

  const closeToggleNav = () => {
    $('.c-meganav__option-wrapper').addClass('hide');
    $('.accordion__title').removeClass('is-open');
    $('.c-meganav__category-label-mobile').css({
      'background': '#fff',
      'color': '#212121',
      'position': 'static'
    })
    $('.c-meganav__category-label-mobile span').css('color', '#212121')
  }

  $('.back__button-sub').click(function () {
    const _this = $(this).parent();
    const that = $(this).parent().parent().parent().parent();
    const subMegaNav = _this.find('.c-sub-meganav');
    const megaNav = that.find('.c-meganav-mobile');
    const subMegaNavs = $('.c-sub-meganav');
    const navCategoryTitle = $('.nav-category-title').attr('data-nav-title');
    const navCategoryTitleChild = $(this).next()[0].innerText;

    slideRoleWrapper.css('opacity', 1);
    $('.nav-category-title .nav-title-custom').text(navCategoryTitle);
    $('.sliderow__title-custom').removeClass('nav-category-title');

    if (subMegaNav.css('visibility') == 'visible') {
      subMegaNavs.css('visibility', 'hidden');
    } else {
      megaNav.css('visibility', 'hidden');
      subMegaNav.css('visibility', 'hidden');
      sliderowTitle.css('visibility', 'visible');
      slideRow.css({
        'visibility': 'visible',
        'height': 0,
        'border-bottom': 'none'
      });
      $('.sliderow__title-custom').css({
        'top': 0,
        'justify-content': 'space-between'
      });
      $('.sliderow__title-custom .accordion__title').css({
        'display': 'flex'
      });
    };

    if (navCategoryTitle == undefined) {
      return;
    } else if (navCategoryTitle.includes('Curtains') && navCategoryTitleChild.includes('Light Filtration')) {
      that.css('height', '250px');
    } else if (navCategoryTitle.includes('Shades') && navCategoryTitleChild.includes('Shop All')) {
      that.css('height', '250px');
    }

    updateSlideRowHeight(navCategoryTitle);
    closeToggleNav();
  });

  const updateSlideRowHeight = () => {
    $('.sliderow').each((i, el) => {
      if (el.style.height == '465px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      } else if (el.style.height == '400px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      } else if (el.style.height == '500px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      } else if (el.style.height == '550px' && $(el)[0].children[0].innerText == 'Curtains') {
        el.style.height = '250px'
        return false;
      }
    })
  }

  function closeVisibleMeganav() {
    if (visibleMeganav) {
      // hide sub menu / meganav
      visibleMeganav.style.visibility = "hidden";
      visibleMeganav.style.opacity = 0;
      visibleMeganav = null;
    }
  }

  function closeVisibleSubMeganav() {
    if (visibleSubMeganav) {
      // hide sub meganav
      visibleSubMeganav.style.visibility = "hidden";
      visibleSubMeganav.style.opacity = 0;
      visibleSubMeganav = null;
    }
    megaNavUnderlay.css('visibility', 'hidden');
  }

  function closeAllVisibleMenus() {
    if (visibleMeganav) {
      visibleMeganav.style.visibility = "hidden";
      visibleMeganav.style.opacity = 0;
      visibleMeganav = null;
    }

    if (visibleSubMeganav) {
      visibleSubMeganav.style.visibility = "hidden";
      visibleSubMeganav.style.opacity = 0;
      visibleSubMeganav = null;
    }
    megaNavUnderlay.css('visibility', 'hidden');
  }
});
